// src/components/AppComponents/Layout/ProtectedLayout.tsx

import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useUserSettingsStore } from '@/domains/user/userSettings.store';
import { useCustomerFiltersLoader } from '@/domains/filters/filters.usecases';
import UserTracking from '../UserTracking';
import Sidebar from '../Sidebar/Sidebar';
// import SideNav from '../Sidebar/SidebarNav';

interface ProtectedLayoutProps {
  isRedirecting?: boolean;
}

/* this components is a layout for the protected routes */
/* it has to be developed */

/* I will have to check if the user, etc. data has already been loaded*/
/* if not, do the corresponding fetch and store the data to access it. */

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ isRedirecting }) => {
  const isCollapsed = useUserSettingsStore(
    (state) => state.settings.menu_collapsed,
  );

  useCustomerFiltersLoader();

  return (
    <div className="static min-h-screen w-full flex flex-col lg:flex-row items-start justify-start lg:justify-between items-center lg:items-stretch">
      {/* <SideNav /> */}
      <Sidebar />
      <UserTracking />

      <main
        className={`content w-full ${isCollapsed ? 'lg:pl-[var(--collapsed-sidebar-width)]' : 'lg:pl-[var(--expanded-sidebar-width)]'} transition-all`}
      >
        {isRedirecting ? (
          <div>Loading...</div>
        ) : (
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        )}
      </main>
    </div>
  );
};

export default ProtectedLayout;
